<span class="label" [class]="labelProductType">{{
  record | prettyProductType
}}</span>
